import { type Entity } from '@lastolivegames/becsy';

import { type EntityId } from '@canvas/model/ecs';

export interface BaseCommandProperties {
  /**
   * The entity associated with the command.
   */
  entity?: Entity;
  /**
   * The groupEntity associated with the command.
   */
  groupEntity?: Entity;
  /**
   * As soon the command is fired, the entity in the command is placed in an entity holder (aka entity registry) and then the entity ID is attached to the command instead.
   * When the command is being drained, the entityID will be used to get the correct entity from the holder and attach it to the command again.
   * If the entity was deleted between the time of dispatch and drain, the command will not be drained since the entity is no longer available to act on.
   */
  entityId?: EntityId;
  /**
   * The original entity that was hit before bubbling promoted interaction to a parent entity.
   */
  originalEntityId?: EntityId;
  /**
   * Internal usage of this attribute is similar to entityID but instead this attribute is used to to keep groupEntityId.
   */
  groupEntityId?: EntityId;
}

export type CommandProperties<T extends BaseCommandProperties> = {
  // So that it respects the exact type of the properties
  [K in keyof T]: T[K];
};

export class Command<C extends BaseCommandProperties = BaseCommandProperties> {
  public constructor(public properties: CommandProperties<C>) {}
}

/**
 * Identifies entity creator commands
 * Used in CommandService to prevent sending such commands if board element limit is reached.
 */
export class CreateEntityCommand<C extends BaseCommandProperties> extends Command<C> {}
